import { updateLinksAttributes } from '../../utils/handleAttributes';
import { missingWidget } from '../../utils/helpers';

export default function seoWidget() {
  const widgetName = 'seoWidget';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof seoWidgetOpts === 'undefined' ? null : seoWidgetOpts;

  if (!widgetOpts) {
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($widget, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomSeo(data.items);
      } else {
        $widget.remove();
      }
    },
  });

  function createCustomSeo(widgetData) {
    const $seo = $widget.find('.card-widget-item');
    const {
      Title,
      Description,
      URL,
      PurchaseURL,
      ImageWithPath,
      ImageAlternateText,
      DetailLinkText,
    } = widgetData[0];

    $seo.replaceWith(`
     <div class="image-section">
      <img class="card-widget-image lozad"" src="${ImageWithPath}" data-src="${ImageWithPath}" alt="${ImageAlternateText}">
    </div>
 
    <div class="text-section">
      <h1 class="main-headline">${Title}</h1>
      ${DetailLinkText == '' ? '' : `<h2 class="sub-headline">${DetailLinkText}</h2>`}
      <div class="seo-description">
        ${Description}
      </div>
    </div>
    `);

    const ariaButton = DetailLinkText == '' ? Title : DetailLinkText;

    if (URL != null || PurchaseURL != null) {
      $widget.find('.text-section').append(`
        <div class="buttons-container">
          ${URL == null ? '' : `<a href="${URL}" class="button" ${updateLinksAttributes(URL, 'Learn More about ' + ariaButton)}>Learn More</a>`}
          ${PurchaseURL == null ? '' : `<a href="${PurchaseURL}" class="button" ${updateLinksAttributes(PurchaseURL, 'Explore ' + ariaButton)}>Explore</a>`}
        </div>
      `);
    }
  }
}
